module.exports = __webpack_public_path__ + "img/idle.1f9ef320.svg";